/** Context icons stay monochrome and inherit the active application theme. */
export const dropdownIconPaths = {
  choices: '<path d="M8 6h13M8 12h13M8 18h13"/><path d="M3 6h.01M3 12h.01M3 18h.01"/>',
  filter: '<path d="M4 7h16M7 12h10M10 17h4"/>',
  sort: '<path d="M8 3v18m-4-4 4 4 4-4M16 3h4M16 8h3M16 13h2"/>',
  calendar: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 11h18"/>',
  globe: '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a18 18 0 0 1 0 18 18 18 0 0 1 0-18"/>',
  users: '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m20 0v-2a4 4 0 0 0-3-3.87"/><circle cx="9" cy="7" r="4"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
  chart: '<path d="M3 3v18h18M8 16v-5M13 16V7M18 16v-9"/>',
  folder: '<path d="M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5l2 2h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2Z"/>',
  tag: '<path d="m20 13-7 7a2 2 0 0 1-3 0l-8-8V2h10l8 8a2 2 0 0 1 0 3Z"/><path d="M7 7h.01"/>',
  text: '<path d="M4 5h16M12 5v15M8 20h8"/>',
  layout: '<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 9v12"/>',
  image: '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8" cy="8" r="1"/><path d="m21 15-5-5L5 21"/>',
  settings: '<path d="M4 7h9m4 0h3M4 17h3m4 0h9"/><circle cx="15" cy="7" r="2"/><circle cx="9" cy="17" r="2"/>',
  status: '<circle cx="12" cy="12" r="9"/><path d="m8 12 3 3 5-6"/>',
  money: '<rect x="2" y="5" width="20" height="14" rx="2"/><circle cx="12" cy="12" r="3"/><path d="M6 12h.01M18 12h.01"/>',
  file: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Zm0 0v6h6M8 13h8M8 17h6"/>',
} as const;

export type DropdownIconName = keyof typeof dropdownIconPaths;

export function dropdownIconMask(icon: DropdownIconName) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">${dropdownIconPaths[icon]}</svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
}

export function dropdownIconFor(label: string): DropdownIconName {
  const rules: [RegExp, DropdownIconName][] = [
    [/sort|order by/i, 'sort'], [/date|time|period|uploaded|schedule/i, 'calendar'],
    [/currency|price|payment|billing|payout/i, 'money'], [/country|language|timezone|region/i, 'globe'],
    [/audience|visibility|member|people|role|privacy/i, 'users'], [/metric|analytics|traffic|chart/i, 'chart'],
    [/folder|destination|source/i, 'folder'], [/category|tag|interest/i, 'tag'],
    [/font|text|heading|weight/i, 'text'], [/layout|align|position|column/i, 'layout'],
    [/image|media|fit|photo|video/i, 'image'], [/status|stage|level|priority/i, 'status'],
    [/form|document|template|file|content/i, 'file'], [/filter/i, 'filter'],
    [/size|unit|setting|mode|style|type/i, 'settings'],
  ];
  return rules.find(([pattern]) => pattern.test(label))?.[1] ?? 'choices';
}
